import http from '@/services/api';

const RESOURCE_NAME = 'api/interaction';
function _useOrganizationIdHeader() {
  const currentAgent = JSON.parse(sessionStorage.getItem('agent'));
  return { headers: { 'organization-id': currentAgent.orgId } };
}

export default {
  acceptInteraction(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/accept`);
  },

  declineInteraction(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/decline`);
  },

  postponeInteraction(interactionId, postponeOptionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/postpone`, { postponeOptionId });
  },

  endInteraction(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/end`);
  },

  startConsult(interactionId, endPoint) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/consult`, { uri: endPoint });
  },

  startConference(interactionId, conversation) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/conference/start`, conversation ? { conversation } : undefined);
  },

  stopConference(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/conference/stop`);
  },

  transferToContact(interactionId, endPoint) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/transfer`, { uri: endPoint });
  },

  transferAttended(interactionId, elementId, endPoint) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/transfer`, { uri: endPoint });
  },

  transferToAutoVM(interactionId) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/transferToAutoVM`);
  },

  transferToSurvey(interactionId) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/transferToSurvey`);
  },

  scheduleCallback(callbackInfo) {
    return http.post(`${RESOURCE_NAME}/callback`, callbackInfo);
  },

  handleCallbackNow(interactionId) {
    return http.post(`${RESOURCE_NAME}/telephony/handleCallbackNow/${interactionId}`);
  },

  holdElement(interactionId, elementId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/hold`);
  },

  resumeElement(interactionId, elementId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/activate`);
  },

  closeElement(interactionId, elementId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/close`);
  },

  startTelephonyInteraction(data) {
    return http.post(`${RESOURCE_NAME}/telephony/dial`, data);
  },

  startChatInteraction(data) {
    return http.post(`${RESOURCE_NAME}/chat`, data);
  },

  startEmailInteraction(data) {
    return http.post(`${RESOURCE_NAME}/email`, data);
  },

  startSMSInteraction(data) {
    return http.post(`${RESOURCE_NAME}/sms`, data);
  },

  updateDispositionCode(interactionId, dispositionCodeId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/dispositionCode`, {
      dispositionCodeId
    });
  },

  updateCompletionStatus(interactionId, completionStatusId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/completionStatus`, {
      completionStatusId
    });
  },

  updateCompletionStatusInformation(interactionId, completionStatusInfomation) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/completionStatusInformation`, completionStatusInfomation);
  },

  updatePendingStatus(interactionId, { pendingStatusName, delegateToSupervisorRemark }) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/pendingStatus`, {
      // Handled
      pendingStatus: pendingStatusName,

      // Optional. Add this field in case of delegating to a supervisor.
      delegateToSupervisorRemark

      // Callback
      // "DestinationAddress":"5553159864",
      // "RoutingType":"1",
      // "RoutingDestinationId":"429963e1-e8c0-4433-ac35-623fe97231a4",
      // "CallbackBusinessProcessId":"faca5418-b1e7-4874-a08a-c8630fb01ae7",
      // "CustomerTimeZoneId":"4",
      // "CallbackStartTime":"2019-12-12T12:12:00.000",
    });
  },

  addRemark(interactionId, remark) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/remark`, { remark });
  },

  getRemarksByAgent(interactionId, agentId) {
    return http.get(`${RESOURCE_NAME}/${interactionId}/remark/all`, { params: { agentId } });
  },

  setCrmContact(interactionId, contactId) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/contact/${contactId}`);
  },

  // Chat
  sendChatMessage(interactionId, elementId, message) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/message`, { message });
  },

  sendSmsMessage(interactionId, elementId, message) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/smsmessage`, { message });
  },

  sendChatNotTypingIndication(interactionId, elementId) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/notTypingIndication`);
  },

  sendChatTypingIndication(interactionId, elementId) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/element/${elementId}/typingIndication`);
  },

  // Telephony
  sendTelephonyDtmf(digit) {
    return http.post(`${RESOURCE_NAME}/telephony/dtmf`, { digitsToSend: digit });
  },

  startCallRecording(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/record/start`);
  },

  stopCallRecording(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/record/stop`);
  },

  pauseCallRecording(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/record/pause`);
  },

  resumeCallRecording(interactionId) {
    return http.put(`${RESOURCE_NAME}/${interactionId}/record/resume`);
  },

  // E-mail
  sendEmail(interactionId, content) {
    const formData = new FormData();
    Object.entries(content).forEach(([key, value]) => {
      if (key === 'attachments') {
        value.forEach(attachment => {
          formData.append(key, attachment, attachment.name);
        });
      } else {
        formData.append(key, value);
      }
    });
    return http.post(`${RESOURCE_NAME}/${interactionId}/sendEmail`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: -1
    });
  },

  replyEmail(interactionId) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/replyEmail`, null, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: -1
    });
  },

  downloadEmailAttachments(interactionId, files) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/downloadEmailAttachments`, { files }, { timeout: -1 });
  },

  getAgentInteractions(agentId) {
    return http.get(`${RESOURCE_NAME}/agent/all`, { params: { agentId } });
  },

  getAgentInteractionConversation(interactionId) {
    return http.get(`${RESOURCE_NAME}/${interactionId}/conversation`);
  },

  getHistorySMSMessages(
    interactionId,
    firstParty,
    secondParty,
    maxNumberOfMessages,
    earliestTime,
    latestTime,
    fullHistory
  ) {
    return http.get(`${RESOURCE_NAME}/sms/history`, {
      params: {
        interactionId,
        firstParty,
        secondParty,
        maxNumberOfMessages,
        earliestTime,
        latestTime,
        fullHistory
      }
    });
  },

  getOutgoingEmailSignature(businessProcessId, email) {
    return http.get(`${RESOURCE_NAME}/email/signature/${businessProcessId}?email=${email}`, _useOrganizationIdHeader());
  },

  getReplyEmailSignature(businessProcessId, email) {
    return http.get(
      `${RESOURCE_NAME}/email/replySignature/${businessProcessId}?email=${email}`,
      _useOrganizationIdHeader()
    );
  },

  updateInteractionVariable({ interactionId, variableName, value }) {
    return http.post(`${RESOURCE_NAME}/${interactionId}/variable`, { variableName, value });
  }
};
